import { __ } from '@wordpress/i18n';
import { PanelBody, RangeControl } from '@wordpress/components';
import Slidereffect from './slider-effect.js';
import {VayuBlocksDevice ,VayuBlocksDeviceControl } from '@vayu-blocks/device-control';
import { VayuBlocksToggleControl, ControlPanelControl } from '@vayu-blocks';
import {VayuBlocksWidthController,VayuBlocksAlignment} from '@vayu-blocks';

const postSettings = ( { attributes, setAttributes, openPanels, onTogglePanel, clientId} ) => {
    const { autoplay, navigation, pagination, simulateTouch, loop, mousewheel, delay, effect, scrollbar, slideslength} = attributes;

    const getView = VayuBlocksDevice();

    const getResponsiveValue = (key) => {
        switch (getView) {
            case 'Desktop':
                return attributes[key];
            case 'Tablet':
                return attributes[`${key}Tablet`];
            case 'Mobile':
                return attributes[`${key}Mobile`];
            default:
                return attributes[key];
        }
    };

    const setResponsiveValue = (key, value) => {
        switch (getView) {
            case 'Desktop':
                setAttributes({ [key]: value });
                break;
            case 'Tablet':
                setAttributes({ [`${key}Tablet`]: value });
                break;
            case 'Mobile':
                setAttributes({ [`${key}Mobile`]: value });
                break;
        }

        // Optional: effect safety check
        if (
            key === 'slidesPerView' &&
            value < 2 &&
            ['flip', 'cards', 'fade'].includes(attributes.effect)
        ) {
            setAttributes({ effect: 'none' });
        }
    };

    const vayu_blocks_manage_loops = (value) => {
        setAttributes( { loop: value } )
        if(value===true && attributes.effect === 'fade'){
            setAttributes({effect:'none'});
        }
    }
    
    return (

        <>

        <PanelBody title={ __( 'Width', 'vayu_blocks' ) } opened={openPanels['slide-size']} onToggle={() => onTogglePanel('slide-size')}>

            <VayuBlocksWidthController 
                onChange={(key, value) => setAttributes({ [key]: value })}
                width={{ key: 'advWidth', value: attributes.advWidth }}
                clientId={clientId}
            />
                                     
        </PanelBody>

        <PanelBody title={ __( 'Slider Settings', 'vayu_blocks' ) } opened={openPanels['slide-image']} onToggle={() => onTogglePanel('slide-image')}>

            <RangeControl
                label={<VayuBlocksDeviceControl label={__('Slides Per View', 'vayu-blocks')} classname='bold' />}
                min={1} // Minimum should be 1 since you can't show 0 slides
                max={5}
                onChange={(value) => setResponsiveValue('slidesPerView', value)}
                value={getResponsiveValue('slidesPerView')}
                __nextHasNoMarginBottom={true}
                marks
            />

            {getResponsiveValue('slidesPerView') >1 && (
                <>
                    <RangeControl
                        __nextHasNoMarginBottom={true}
                        label={<VayuBlocksDeviceControl label={__('Space Between', 'vayu-blocks')} classname='bold' />}
                        min={0} // Minimum should be 1 since you can't show 0 slides
                        max={100}
                        onChange={(value) => setResponsiveValue('spaceBetween',value)} 
                        value={getResponsiveValue('spaceBetween')}
                    />
                </>
            )}

            <div className="vb-toggle-wrapper-slider">
         
                <VayuBlocksToggleControl
                    label={ __( 'Autoplay', 'vayu_blocks' ) }
                    checked={ autoplay }
                    onChange={ ( value ) =>setAttributes( { autoplay: value } )}
                    help={ __('This settings will only take effect once you are on the live page.','vayu_blocks') }
                />

                {autoplay && (
                    <>
                        <ControlPanelControl
                            label={ __( 'Autoplay Settings', 'vayu-blocks' ) }
                            popoverClass="vb-slider-popover-class"
                        >

                        <RangeControl
                            label={ __( 'Delay in ms', 'vayu_blocks' ) }
                            value={ delay }
                            min={1}
                            max={5000}
                            onChange={ ( value ) => setAttributes( { delay: value } )}
                        />

                        <br/>
                        <VayuBlocksToggleControl
                            label={ __( 'Disable On Interaction', 'vayu_blocks' ) }
                            checked={ attributes.disableOnInteraction }
                            onChange={ ( value ) =>
                                setAttributes( { disableOnInteraction: value } )
                            }
                        />
                        <br/>
                        <VayuBlocksToggleControl
                            label={ __( 'Pause On Mouse Enter', 'vayu_blocks' ) }
                            checked={ attributes.pauseOnMouseEnter }
                            onChange={ ( value ) =>
                                setAttributes( { pauseOnMouseEnter: value } )
                            }
                        />
                        <br/>
                        <VayuBlocksToggleControl
                            label={ __( 'Reverse Direction', 'vayu_blocks' ) }
                            checked={ attributes.reverseDirection}
                            onChange={ ( value ) =>
                                setAttributes( { reverseDirection: value } )
                            }
                        />

                        </ControlPanelControl>
                    
                    </>
                )}

                {autoplay &&(
                    <br/>
                )}
            
                <VayuBlocksToggleControl
                    label={ __( 'Infinite (Loop)', 'vayu_blocks' ) }
                    checked={ loop }
                    onChange={ ( value ) =>vayu_blocks_manage_loops(value)}
                    help={ __('This settings will only take effect once you are on the live page.','vayu_blocks') }
                />

                <VayuBlocksToggleControl
                    label={ __( 'Navigation', 'vayu_blocks' ) }
                    checked={ navigation }
                    onChange={ ( value ) => setAttributes( { navigation: value } )}
                />

                <VayuBlocksToggleControl
                    label={ __( 'Pagination', 'vayu_blocks' ) }
                    checked={ pagination }
                    onChange={ ( value ) =>setAttributes( { pagination: value } )}
                />

                <VayuBlocksToggleControl
                    label={ __( 'Scroll Bar (On Hover)', 'vayu_blocks' ) }
                    checked={ scrollbar }
                    onChange={ ( value ) =>setAttributes( { scrollbar: value } )}
                />

                <VayuBlocksToggleControl
                    label={ __( 'Mouse Wheel', 'vayu_blocks' ) }
                    checked={ mousewheel }
                    onChange={ ( value ) =>setAttributes( { mousewheel: value } )}
                />

                <VayuBlocksToggleControl
                    label={ __( 'SimulateTouch', 'vayu_blocks' ) }
                    checked={ simulateTouch }
                    onChange={ ( value ) => setAttributes( { simulateTouch: value } )}
                    help={ __('This allows users to drag slides using a touch gestures.','vayu_blocks') }
                />

            </div>

            <RangeControl
                __nextHasNoMarginBottom={true}
                __next40pxDefaultSize={true}
                label={<VayuBlocksDeviceControl label={__('Initial Slide', 'vayu-blocks')} classname='bold' />}
                min={1}
                max={slideslength}
                onChange={(value) => setResponsiveValue('initialSlide', value)} 
                value={getResponsiveValue('initialSlide')}
                marks
            />

        </PanelBody>

        <PanelBody title={ __( 'Effect', 'vayu_blocks' ) } opened={openPanels['slide-effect']} onToggle={() => onTogglePanel('slide-effect')} >
            
            <div className='vb-slider-effect-panel'>
                <Slidereffect
                    imageanimationValue={effect} 
                    onimageAnimationChange={ ( value ) =>
                        setAttributes({effect:value})
                    }
                    loop = {attributes.loop}
                    slidesPerView={attributes.slidesPerView}
                />
            </div>

        </PanelBody>

        </>
    );
};

export default postSettings;